import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ShareIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Share",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M22.98 30H9.01c-1.93 0-3.49-1.56-3.49-3.49V16.04c0-1.93 1.56-3.49 3.49-3.49h1.7a1.16 1.16 0 0 1 0 2.32h-1.7c-.64 0-1.16.52-1.16 1.16V26.5c0 .64.52 1.16 1.16 1.16h13.97c.64 0 1.16-.52 1.16-1.16V16.03c0-.64-.52-1.16-1.16-1.16h-1.75a1.16 1.16 0 0 1 0-2.32h1.75c1.93 0 3.49 1.56 3.49 3.49v10.47c0 1.93-1.56 3.49-3.49 3.49m-.9-19.85c-.32 0-.61-.13-.82-.34l-4.99-4.99-4.99 4.99a1.16 1.16 0 0 1-1.64-1.64s5.82-5.82 5.82-5.82a1.156 1.156 0 0 1 1.64 0l5.82 5.82c.21.21.34.5.34.83 0 .64-.52 1.16-1.16 1.16Zm-5.82 10.47c-.64 0-1.16-.52-1.16-1.16V3.16a1.16 1.16 0 0 1 2.32 0v16.29c0 .64-.52 1.16-1.16 1.16Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22 7.86c-.29 0-.58-.11-.81-.33l-4.91-4.91-4.91 4.91c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62L15.48.19a1.14 1.14 0 0 1 1.62 0l5.71 5.71A1.14 1.14 0 0 1 22 7.85Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.29 21.57c-.63 0-1.14-.51-1.14-1.14V1a1.14 1.14 0 1 1 2.28 0v19.43c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24.29 31.86h-16c-1.89 0-3.43-1.54-3.43-3.43V14.72c0-1.89 1.54-3.43 3.43-3.43h3.43a1.14 1.14 0 1 1 0 2.28H8.29c-.63 0-1.14.51-1.14 1.14v13.71c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14V14.71c0-.63-.51-1.14-1.14-1.14h-3.43a1.14 1.14 0 1 1 0-2.28h3.43c1.89 0 3.43 1.54 3.43 3.43v13.71c0 1.89-1.54 3.43-3.43 3.43"
      })]
    })
  }));
};
ShareIcon.displayName = 'ShareIcon';